import React, { useEffect, useState } from "react";

import { Button, Offcanvas } from "react-bootstrap";

import { isLargeScreen } from "@/utils/Toolbox";

import ReserveCheckoutComponent from "./ReserveCheckout.component";
import useReserveContext from "../../hooks/useReserveContext";
import i18n from "../../i18n";
import ConfirmComponent from "../Confirm.component";
import { trackEvent } from "../GA.component";

interface ReserveModalComponentProps {
  btnClass?: string;
  btnVariant?: string;
}

const ReserveModalComponent = ({
  btnClass = "p-1 ps-5 pe-5",
  btnVariant = "primary",
}: ReserveModalComponentProps): React.JSX.Element => {
  const {
    openSection,
    setOpenSection,
    showConfirmModal,
    setShowConfirmModal,
    hasError,
  } = useReserveContext();
  const { t } = i18n;
  const [placement, setPlacement] = useState<"bottom" | "end">("end");
  useEffect(() => {
    const handleResize = () => {
      setPlacement(isLargeScreen() ? "end" : "bottom");
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <Button
        className={btnClass}
        variant={btnVariant}
        onClick={() => {
          setOpenSection(true);
          trackEvent("reserve_open_modal");
        }}
      >
        {t("Reserve Today")}
      </Button>

      <ConfirmComponent
        closeLabel={t("No, Continue Reserving")}
        confirmLabel={t("Yes, Exit")}
        onConfirm={() => setShowConfirmModal(false)}
        onHide={() => setShowConfirmModal(false)} // same as confirm!
        show={showConfirmModal}
        bodyNode={
          <p className="text-center p-1 ps-5 pe-5">
            {t(
              "Your reservation isn’t complete, are you sure you want to exit?",
            )}
          </p>
        }
        onClose={() => {
          setOpenSection(false);
          setShowConfirmModal(false);
        }}
      />

      <Offcanvas
        scroll
        backdrop="static"
        className="reserve-modal"
        onHide={() => (!hasError ? setShowConfirmModal(true) : {})}
        placement={placement}
        show={openSection}
      >
        <Offcanvas.Header />
        <Offcanvas.Body>
          {openSection ? (
            <React.Fragment>
              {!hasError && (
                <Button
                  className="d-flex justify-content-center ms-auto reserve-modal-close-btn "
                  onClick={() => setShowConfirmModal(true)}
                >
                  &times;
                </Button>
              )}
              <ReserveCheckoutComponent />
            </React.Fragment>
          ) : null}
        </Offcanvas.Body>
      </Offcanvas>
    </React.Fragment>
  );
};

export default ReserveModalComponent;
